// extracted by mini-css-extract-plugin
export default {"centered":"DrawerForm-centered_ZAjy6","reversedBackgroundAlert":"DrawerForm-reversedBackgroundAlert_N77yu"};